export const MessageTransition = {
  functional: true,
  render(h, { children }) {
    const data = {
      attrs: { tag: 'div', name: 'message', type: 'transition' },
    };
    return h('transition-group', data, children);
  },
};
